// @flow
import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import _ from "lodash";
import { compose } from "redux";

import withRoundSelector from "../../../components/utils/withRoundsSelector";
import { below } from "../../../assets/css/media";
import * as actions from "../../../modules/actions";
import * as selectors from "../../../modules/selectors";
import type { 
	TPLeague, 
	TRoundsById, 
	TRound, 
	TPlayersById, 
	TCoachPlayerStatsById,
	TDraftTeamsById
} from "../../../modules/types";
// import type { TPLeague } from "../../../modules/types";

import {
	Footer,
	PageContentWrapper,
	PageTitle,
	RoundSelector,
	TwoColumnLayout,
	Ad,
	AdsContainer,
	MatchCentreBar,
	StandardSidebar,
	AdFantasyCoach,
	LeagueGameBar,
	Exist
} from "../../../components";
import Fixtures from "../../../components/Fixtures/Fixtures";
import JsonFetcher from "../../../components/utils/JsonFetcher";

import { getLeagueRoundAliases, getLeagueFinalFullNames } from "../../../helpers/league";
import withCoachesBox from "../../../components/utils/withCoachesBox";
import MatchupHoldingMessage from "../../../components/MatchupHoldingMessage";
import { isAllTrue } from "../../../helpers";

const FixturesWrapper = styled.div`
	margin-bottom: 50px;
`;

const PageHeaderWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	${below.phone`
		.round-selector{
			width: 100%;
			select{
				width: 100%;
			}
		}
	`}
`;

type Props = {
	selected_league_id: number,
	ladder_teams_by_id: TDraftTeamsById,
	ladder_teams_ordered: Object,
	fetchLeague: typeof actions.leagueDraft.showDraftLeague,
	fetchLadder: typeof actions.leagueDraft.ladderDraftLeague,
	fetchRounds: typeof actions.fetchRounds,
	is_pending_show: boolean,
	is_pending_ladder: boolean,
	user_id: number,
	rounds_ordered: Array<Object>,
	rounds_by_id: TRoundsById,
	rounds_with_matches: Array<Object>,
	selected_round_id: number,
	actual_round: TRound,
	setSelectedRoundId: Function,
	league: TPLeague,
	has_assistant_coach: boolean,
	coach_players_by_id: TCoachPlayerStatsById,
	match: {
		params: {
			league_id: number
		}
	},
	players_by_id: TPlayersById
};

class LeagueFixtures extends React.Component<Props> {

	componentDidMount() {
		const { league_id } = this.props.match.params;
		const { fetchLeague, fetchLadder } = this.props;
		fetchLeague({ id: league_id });
		fetchLadder({ league_id });
	}

	componentDidUpdate(prev_props) {
		const { selected_league_id, selected_round_id } = this.props;

		if (
			selected_league_id !== prev_props.selected_league_id
		) {
			this.fetchLeague();
			this.fetchLadder();
		}
		else if (
			isAllTrue([
				selected_round_id !== prev_props.selected_round_id,
				Boolean(prev_props.selected_round_id)
			])
			
		) {
			this.fetchLadder();
		}

		this.checkShouldSetRound(prev_props);
	}

	checkShouldSetRound(prev_props: Props) {
		const { selected_league_id, league, setSelectedRoundId, actual_round } = this.props;
		if (
			selected_league_id !== prev_props.selected_league_id 
			|| league !== prev_props.league
			|| (actual_round && !prev_props.actual_round)
		) {
			setSelectedRoundId(this.league_selected_round);
		}
	}

	fetchLadder() {
		const { fetchLadder, selected_league_id, selected_round_id } = this.props;
		fetchLadder({
			league_id: selected_league_id,
			round: selected_round_id
		});
	}

	fetchLeague() {
		const { fetchLeague, selected_league_id } = this.props;
		fetchLeague({
			id: selected_league_id
		});
	}

	get is_league_bye_round() {
		const {
			rounds_by_id,
			league,
			selected_round_id
		} = this.props;

		if (rounds_by_id && selected_round_id && league) {
			const round = rounds_by_id[selected_round_id];
			return Boolean(league.bye_rounds) ? false : round.is_bye;
		}

		return false;
	}

	get league_current_round_fixtures() {
		const { league, selected_round_id } = this.props;
		return selected_round_id ?
			_.get(league, `fixture.${selected_round_id}`, []): [];
	}

	get league_rounds() {
		const {
			rounds_ordered,
			league
		} = this.props;

		if (rounds_ordered && league && league.start_round && league.end_round) {
			return rounds_ordered.filter(round =>
				round.id >= league.start_round && round.id <= league.end_round
			);
		}

		return rounds_ordered;
	}

	get finals_rounds() {
		const {
			rounds_ordered,
			league
		} = this.props;

		return getLeagueRoundAliases(league, rounds_ordered);
	}

	get finals_names() {
		const {
			rounds_ordered,
			league
		} = this.props;

		return getLeagueFinalFullNames(league,  rounds_ordered);
	}

	get league_selected_round() {
		const { selected_round_id, league } = this.props;

		if (selected_round_id && league) {
			const start_round = _.first(this.league_rounds).id;
			const end_round = _.last(this.league_rounds).id;

			if ( selected_round_id < start_round) {
				return start_round;
			}
			else if (selected_round_id > end_round) {
				return end_round;
			}

			return selected_round_id;
		}

		return  null;
	}

	render() {
		const {
			setSelectedRoundId,
			ladder_teams_by_id,
			league,
			rounds_with_matches,
			has_assistant_coach,
			coach_players_by_id,
			selected_round_id,
			actual_round,
			players_by_id,
			ladder_teams_ordered,
			user_id
		} = this.props;

		return (
			<React.Fragment>
				<JsonFetcher fetch={["rounds", "coach_players", "players", "squads", "venues"]} />

				<LeagueGameBar no_fetch={true} />

				<AdsContainer>
					<Ad />
				</AdsContainer>

				

				<PageContentWrapper>
					
					
					<TwoColumnLayout>
						
						<FixturesWrapper>
							<PageHeaderWrapper>
								<PageTitle>
							Fixtures for {league && league.name} 
								</PageTitle>
								<RoundSelector
									selected={selected_round_id}
									rounds={this.league_rounds}
									handleClick={setSelectedRoundId}
									round_aliases={this.finals_rounds}
									className="round-selector"
								/>
							</PageHeaderWrapper>
							<Exist when={["scheduled", "active"].includes(league.draft_status)}>
								<MatchupHoldingMessage 
									league_id={league.id} 
									is_fixture_page={true} 
								/>
							</Exist>
							<Exist when={league.draft_status === "complete"}>
								<Fixtures
									league={league}
									ladder_teams_by_id={ladder_teams_by_id}
									ladder_teams_ordered={ladder_teams_ordered}
									rounds_with_matches={rounds_with_matches}
									has_assistant_coach={has_assistant_coach}
									coach_players_by_id={coach_players_by_id}
									selected_round_id={selected_round_id}
									is_league_bye_round={this.is_league_bye_round}
									league_current_round_fixtures=
										{this.league_current_round_fixtures}
									actual_round={actual_round}
									players_by_id={players_by_id}
									finals={this.finals_names}
									league_fixture={true}
									user_id={user_id}
								/>
							</Exist>
						
							<AdFantasyCoach type="leaderboard" small_screen_only />
						</FixturesWrapper>
						<StandardSidebar />
					</TwoColumnLayout>
				</PageContentWrapper>
				<MatchCentreBar />
				<Footer />
			</React.Fragment>
		);
	}
}


const mapStateToProps = (state, props) => ({
	selected_league_id: props.match.params.league_id,
	league: selectors.leagues.getLeague(state, props),
	is_pending_show: selectors.leagues.show.isPending(state),
	is_pending_ladder: selectors.leagues.ladder.isPending(state),
	ladder_teams_by_id: selectors.leagues.ladder.getById(state),
	ladder_teams_ordered: selectors.orderedLadderCalculated(state, props),
	user_id: selectors.getUser(state).id,
	has_assistant_coach: Boolean(selectors.getUser(state).assistant_coach),
	coach_players_by_id: state.players.coach_by_id,
	actual_round: selectors.rounds.getActualRound(state),
	players_by_id: selectors.players.getExtendedPlayersById(state),
	rounds_with_matches: selectors.rounds.getRoundsWithMatches(state),
});

const mapDispatchToProps = {
	fetchLeague: actions.leagueDraft.showDraftLeague,
	fetchLadder: actions.leagueDraft.ladderDraftLeague
};

export const DraftLeagueFixtures = compose(
	withRoundSelector,
	withCoachesBox,
	connect(mapStateToProps, mapDispatchToProps)
)(LeagueFixtures);


export default DraftLeagueFixtures;